import { render, staticRenderFns } from "./SpecializationDeleteModal.vue?vue&type=template&id=db428c78&scoped=true"
import script from "./SpecializationDeleteModal.vue?vue&type=script&lang=js"
export * from "./SpecializationDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./SpecializationDeleteModal.vue?vue&type=style&index=0&id=db428c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db428c78",
  null
  
)

export default component.exports